import { BaseApiClient } from './base-client';

export interface LinkStatus {
  hasTelegram: boolean;
  hasGoogle: boolean;
  authType: string;
  googleEmail: string | null;
  telegramUsername: string | null;
  linkedAt: string | null;
  canUnlink: boolean;
  unlinkCooldownUntil: string | null;
}

export class AccountLinkingApi extends BaseApiClient {

  /** Получить статус привязки */
  async getStatus(): Promise<{ success: boolean; linkStatus: LinkStatus }> {
    const response = await this.client.get('/api/account-linking/status');
    return response.data;
  }

  /** TG-пользователь привязывает Google (отправляет code после OAuth) */
  async linkGoogle(code: string, state?: string): Promise<{
    success: boolean;
    message?: string;
    error?: string;
    user?: { authType: string; googleEmail: string };
  }> {
    const response = await this.client.post('/api/account-linking/link-google', { code, state });
    return response.data;
  }

  /** Google-пользователь запрашивает привязку Telegram */
  async requestLinkTelegram(telegramUsername: string): Promise<{
    success: boolean;
    requestId: number;
    message?: string;
    error?: string;
  }> {
    const response = await this.client.post('/api/account-linking/request-link-telegram', { telegramUsername });
    return response.data;
  }

  /** Поллинг статуса запроса привязки */
  async getRequestStatus(requestId: number): Promise<{
    success: boolean;
    status: 'pending' | 'confirmed' | 'rejected' | 'expired';
  }> {
    const response = await this.client.get(`/api/account-linking/request-status/${requestId}`);
    return response.data;
  }

  /** Отвязка Google от TG-аккаунта */
  async unlink(): Promise<{
    success: boolean;
    message?: string;
    error?: string;
  }> {
    const response = await this.client.post('/api/account-linking/unlink');
    return response.data;
  }
}
